export default __webpack_public_path__ + "static/splash-7304206fc92c78a6db236cbb09af4a53.png";